import { useFilter } from "context/FilterContext";
import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import SubStockSetsProducts from "features/Stock/SubStocktSetProduct/components/SubStockSetProducts";
import React from "react";
import { useLocation } from "react-router-dom";

const SubStockSetProduct = () => {
  const { setSortOptions, setSelectedSortValue, selectedSortValue, sortOptions } = React.useContext(SortContext);
  const { setFilter, setFilterValues, setBackendFilterValues, setFilterCount } = useFilter();
  const { setDisplaySetIcon, setBreadCrumbLock, setSearchPlaceHolder } = useGlobalContext();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isFilter = searchParams.get("isFilter") === "true";
  React.useEffect(() => {
    setDisplaySetIcon(true);
    setBreadCrumbLock(true);
    setFilter(true);
    setSortOptions([
      { id: 1, name: "Design No. (Low to High)", sortBy: "Design No", order: "asc" },
      { id: 2, name: "Design No. (High to Low)", sortBy: "Design No", order: "desc" },
      { id: 3, name: "Design Date (Oldest to Newest)", sortBy: "Design Date", order: "asc" },
      { id: 4, name: "Design Date (Newest to Oldest)", sortBy: "Design Date", order: "desc" },
      { id: 5, name: "Make Date (Oldest to Newest)", sortBy: "Make Date", order: "asc" },
      { id: 6, name: "Make Date (Newest to Oldest)", sortBy: "Make Date", order: "desc" },
      { id: 7, name: "Gold Net Weight (Low to High)", sortBy: "Gold Net Weight", order: "asc" },
      { id: 8, name: "Gold Net Weight (High to Low)", sortBy: "Gold Net Weight", order: "desc" },
      { id: 9, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
      { id: 10, name: "Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },
      {
        id: 11,
        name: "Sales (Low to High)",
        sortBy: "Sales",
        order: "asc",
      },
      {
        id: 12,
        name: "Sales (High to Low)",
        sortBy: "Sales",
        order: "desc",
      },
    ]);
    setSearchPlaceHolder("Search By Jewel Code");

    return () => {
      setSearchPlaceHolder("Search");
      setFilter(false);
      setBreadCrumbLock(false);
      setDisplaySetIcon(false);
      setFilterValues({
        "Diamond Quality": [],
        "Gold Purity": [],
        "Gold Color": [],
        Location: [],
      });
      setFilterCount(0);
      setSortOptions([]);
      setSelectedSortValue(null);
      sessionStorage.removeItem("appliedSortValue");
    };
  }, []);

  React.useEffect(() => {
    sessionStorage.setItem("appliedSortValue", selectedSortValue);
  }, [selectedSortValue, sortOptions]);

  React.useEffect(() => {
    const fetchFilterData = async () => {
      try {
        let filterData = {
          "Diamond Quality": ["VVS-EF", "VVS-FG", "VVS-GH", "VSSI-GH", "VS-GH", "SI-IJ", "SI-HI"],
          "Gold Purity": ["22K", "18K", "14K"],
          "Gold Color": ["Yellow Gold", "Rose Gold", "White Gold"],
          Class: ["Gold", "Silver", "Bronze", "Under Ratio"],
          "Stock Status": ["All"],
          "Show Hidden Designs":false
        };

        if (isFilter) {
          const storedFilters = JSON.parse(sessionStorage.getItem("aiStockFilters") || "{}");
          if (storedFilters?.locationList && storedFilters?.locationList?.length > 0) {
            filterData.Location = storedFilters.locationList.map((loc) => (loc === "Idel Inventory" ? "IDL" : loc));
          } else {
            filterData.Location = ["Headquarters Stock", "BBM Stock", "BBM Customer Stock", "BBS Stock", "BBS Customer Stock", "IDL"];
          }
          if (storedFilters?.stockStatus) {
            filterData["Stock Status"] = storedFilters.stockStatus === "Memo" ? ["On Memo"] : [storedFilters?.stockStatus];
          }
        } else {
          let isNormalFilter = JSON.parse(sessionStorage.getItem("appliedFilterValues") || "{}");

          filterData.Location = isNormalFilter?.Location?.length > 0 ? isNormalFilter.Location : ["Headquarters Stock", "BBM Stock", "BBM Customer Stock", "BBS Stock", "BBS Customer Stock", "IDL"];

          if (isNormalFilter?.["Stock Status"]) {
            filterData["Stock Status"] = isNormalFilter["Stock Status"][0] === "Memo" ? ["On Memo"] : [isNormalFilter["Stock Status"][0]];
          }

          // setFilterCount(0);
        }

        let backendFilterData = {
          "Diamond Quality": ["VVS-EF", "VVS-FG", "VVS-GH", "VSSI-GH", "VS-GH", "SI-IJ", "SI-HI"],
          "Gold Purity": ["22K", "18K", "14K"],
          "Gold Color": ["Yellow Gold", "Rose Gold", "White Gold"],
          Class: ["Gold", "Silver", "Bronze", "Under Ratio"],
          Location: ["Headquarters Stock", "BBM Stock", "BBM Customer Stock", "BBS Stock", "BBS Customer Stock", "IDL"],
          "Stock Status": ["All", "On Hand", "On Memo"],
          "Show Hidden Designs":[]
        };

        // Update the state with the fetched data
        setBackendFilterValues((prev) => backendFilterData);
        setFilterValues((prev) => filterData);
      } catch (error) {
        console.error("Error fetching filter data:", error);
      }
    };

    fetchFilterData();
  }, []);

  return <SubStockSetsProducts />;
};

export default SubStockSetProduct;
